import { ApolloClient } from '@apollo/client';
import { DocumentPayload } from './document-interface.types';
import { graphql } from '../../gql';

const query = graphql(/* GraphQL */ `
  query GetDocumentByIdOffer($documentId: ID!) {
    getDocumentById(id: $documentId) {
      id
      approvalRequest {
        id
        status
        threshold
        permitEditingDuringApproval
        useApprovalOrder
        currentApprover {
          id
          fullName
          email
        }
        creator {
          id
        }
        reviewers {
          id
        }
        reviews {
          id
          approvedAt
          rejectedAt
          approvalOrder
          lastReminderSentAt
          reviewer {
            id
            fullName
            email
          }
        }
        totalReviews
        totalApproved
      }
      isEditable
      isEligibleForSigningPrep
      isTitleEditable
      shouldReturnForReceiverReview
      status
      document
      title
      lastUpdated
      eversignStatus
      eversignPdfUrl
      signedPdfUrl
      receiverCollaborationEnabled
      receiverPagePdfEditingEnabled
      generatedDocumentPdfUrl
      currentTeamPossession
      documentSuggestions {
        id
        externalId
        status
      }
      receiverTeam {
        id
      }
      team {
        id
      }
      signers {
        id
        order
        email
        embeddedSigningUrl
        token
        signedAt
      }
      deal {
        id
        receiverEmail
        title
        status
      }
      editorConfiguration
      source
      importedAssetUrl
      importedAssetContentType
      useSignerOrder
      counterpartyPermissionLevel
    }
  }
`);

export const getDocumentById =
  (documentId: string | number) =>
  (client: ApolloClient<object>): Promise<DocumentPayload> => {
    const variables = { documentId: documentId as string };

    return client.query({ query, variables }).then(({ data }: Record<any, any>) => data.getDocumentById);
  };

export const getDocumentByIdOfferQuery = query;
